import { CheckCircleIcon, InfoIcon } from '@chakra-ui/icons';
import {
	Box,
	Button,
	Card,
	Divider,
	Flex,
	Heading,
	List,
	ListIcon,
	ListItem,
	SimpleGrid,
	Stack,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { NAVIGATE } from 'constant/navigation';
import { useLocation, useNavigate } from 'react-router-dom';
import EducationLinks from 'views/client/education/components/EducationLinks';

export default function Cashback() {
	const textColor = useColorModeValue('gray.900', 'gray.100');
	const cardBg = useColorModeValue('gray.100', 'gray.500');
	const accent = useColorModeValue('brand.500', 'brand.300');
	const navigate = useNavigate();
	const location = useLocation();
	let isClient = false;
	if (location.pathname.includes('client')) isClient = true;

	return (
		<Box
			maxW={isClient ? '' : '900px'}
			alignSelf={isClient ? '' : 'center'}
			pt={isClient ? { base: '80px', md: '80px', xl: '80px' } : '0'}
		>
			<SimpleGrid
				mb='20px'
				columns={{ sm: 1, md: 1, lg: 1 }}
				spacing={{ base: '20px' }}
			>
				<Heading color={textColor} fontSize='2xl' ms='24px' fontWeight='700'>
					Gana más cashback
				</Heading>
				<Flex direction='column'>
					<Card bg={cardBg} mb={isClient ? '20px' : '50px'} p={6}>
						<Stack spacing={6}>
							<Text fontSize='md' color={textColor}>
								En Bumbei, cada clic cuenta. Aquí tienes algunos consejos para
								aprovechar al máximo tus compras:
							</Text>

							<List spacing={3} color={textColor}>
								<ListItem>
									<ListIcon as={InfoIcon} color={accent} />
									Siempre inicia sesión antes de hacer clic en una tienda
								</ListItem>
								<ListItem>
									<ListIcon as={InfoIcon} color={accent} />
									Realiza la compra justo después de hacer clic (no cierres la
									pestaña)
								</ListItem>
								<ListItem>
									<ListIcon as={InfoIcon} color={accent} />
									No uses cupones externos no listados en Bumbei
								</ListItem>
								<ListItem>
									<ListIcon as={InfoIcon} color={accent} />
									Guarda tu recibo por si necesitas abrir una disputa
								</ListItem>
								<ListItem>
									<ListIcon as={InfoIcon} color={accent} />
									Invita amigos y gana aún más con referidos
								</ListItem>
							</List>
							<Divider />

							<Text fontSize='md' color={textColor}>
								Cada tienda tiene reglas diferentes, pero si sigues estos pasos,
								tu cashback se registrará correctamente y será aprobado sin
								problemas.
							</Text>
							<Heading fontSize='2xl' mb={4} color={textColor}>
								¿Cómo retiro mis sats?
							</Heading>
							<Text mb={4} color={textColor}>
								Retirar tu saldo en bitcoin es muy fácil. Solo necesitas tener
								una wallet compatible con Lightning Network y copiar tu factura
								(invoice).
							</Text>

							<Divider my={6} />

							<Heading fontSize='xl' mb={3}>
								📲 Paso a paso:
							</Heading>
							<List spacing={3} color={textColor}>
								<ListItem>
									<ListIcon as={CheckCircleIcon} color={accent} />
									Abre tu wallet (te recomendamos Muun o Blink)
								</ListItem>
								<ListItem>
									<ListIcon as={CheckCircleIcon} color={accent} />
									Crea una factura (invoice) por el monto que quieras retirar
								</ListItem>
								<ListItem>
									<ListIcon as={CheckCircleIcon} color={accent} />
									Copia y pega el código en el campo de retiro en Bumbei
								</ListItem>
							</List>

							<Divider my={6} />

							<Heading fontSize='xl' mb={3}>
								🔍 ¿No tienes una wallet?
							</Heading>
							<Text mb={4} color={textColor}>
								Aquí tienes una guía para descargar una:
							</Text>
							<List spacing={3} color={textColor}>
								<ListItem>
									<ListIcon as={InfoIcon} color={accent} />
									<strong>Muun Wallet:</strong> segura, fácil y no custodiada.
								</ListItem>
								<ListItem>
									<ListIcon as={InfoIcon} color={accent} />
									<strong>Blink Wallet:</strong> ideal para empezar en segundos.
								</ListItem>
							</List>

							<Divider my={6} />

							<Heading fontSize='xl' mb={3}>
								🧠 Tips de confianza
							</Heading>
							<Text mb={6} color={textColor}>
								Recibirás tus sats al instante. No hay mínimos y no cobramos
								comisiones. Es tu recompensa por usar Bumbei 🎉
							</Text>
							{isClient && (
								<Box pt={4}>
									<Button
										as='a'
										onClick={() => navigate(NAVIGATE.EDUCATION_CENTER)}
										variant='brand'
									>
										Volver al centro educativo
									</Button>
								</Box>
							)}
						</Stack>
					</Card>
					<EducationLinks current={'cashback'} isClient={isClient} />
				</Flex>
			</SimpleGrid>
		</Box>
	);
}
